import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=67e52a0e&scoped=true&"
import script from "./PoweredBy.vue?vue&type=script&lang=js&"
export * from "./PoweredBy.vue?vue&type=script&lang=js&"
import style0 from "./powered-by.scss?vue&type=style&index=0&id=67e52a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e52a0e",
  null
  
)

export default component.exports